import React from "react";

import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "@/components/ui/card";
import { Link } from "@/lib/i18n";
import * as m from "@/paraglide/messages";

type Props = {};

export default function bentoIntro({}: Props) {
  return (
    <>
      <Card className="w-full">
        <CardHeader></CardHeader>
        <CardContent>
          <div className="flex flex-col items-start gap-4">
            <Badge>{m.smart_allocation()}</Badge>

            <h2 className="mb-4 text-2xl  lg:text-4xl font-extrabold">
              {m.lucky_whole_beaver_kick()}
            </h2>
            <p className="mb-6 text-balance">{m.cute_spare_tadpole_push()}</p>
            <div className="flex space-x-4">
              <Button variant="default">
                <Link href="#pricing">{m.get_started()}</Link>
              </Button>
            </div>
          </div>
        </CardContent>
        <CardFooter></CardFooter>
      </Card>
    </>
  );
}
